/**
 * ドメイン別デフォルト遷移先の解決ヘルパー。
 *
 * `?poster=<id>` 無しでアクセスされた時、hostname に応じて posters.json 上の
 * `_domainDefaults` マップを引いて遷移先 URL を返す。クライアントのカスタムドメイン
 * (ar.<client>.co.jp) にパラメータなしで着地したユーザーを、そのクライアント自身の
 * コーポレートサイトへ導くための機構。
 *
 * `_domainDefaults` の形式:
 *   {
 *     "ar.syukaso.com": "https://syukaso.com/",
 *     "ar.enters-lab.co.jp": "https://enters-lab.co.jp/articles/20251028/",
 *     "*": "https://enters-lab.co.jp/articles/20251028/"
 *   }
 *
 * 優先順: hostname 完全一致 → '*' フォールバック → 引数の fallback。
 */

/**
 * @param {string} hostname - window.location.hostname
 * @param {Object|null|undefined} postersJson - posters.json 全体
 * @param {string} fallback - どちらも解決できない時の最終フォールバックURL
 * @returns {string}
 */
export function resolveDomainDefaultUrl(hostname, postersJson, fallback) {
  const defaults = postersJson?._domainDefaults;
  if (!defaults || typeof defaults !== 'object') return fallback;
  const hit = defaults[hostname];
  if (typeof hit === 'string' && hit) return hit;
  const wild = defaults['*'];
  if (typeof wild === 'string' && wild) return wild;
  return fallback;
}
